import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  firmasList:[],
};
export const mutations = {
  GET_FIRMAS({ context }, firmas) {
    let firmas_array = [];
    Object.entries(firmas).forEach(([key, val]) => firmas_array.push(val));
    return (state.firmasList = firmas_array);
  },
};
export const actions = {
  FIREL_FIRMA({ commit }, data) {
    // console.log(data);
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.post(data)
          .then(response => {
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_FIRMA_MAGISTRADO({ commit }, data) {
    // console.log(data);
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.post(data)
          .then(response => {
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  CREATE_MULTIFIRMA({ commit }, data) {
    // console.log(data);
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.post(data)
          .then(response => {
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  EDIT_MULTIFIRMA({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          // commit("EDIT_MULTIFIRMA", response.data);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_FIRMAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response.data);
          commit("GET_FIRMAS", response.data.data.firmas);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_FIRMADOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response.data);
          // commit("GET_FIRMADOS", response.data.data.firmas);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_PENDIENTES_FIRMAR({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_PENDIENTES_FIRMAR", response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

};

export const getters = {
  firmasList: state => state.firmasList
};
